import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
export function HookSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 relative" data-id="element-71">
      <div className="max-w-3xl mx-auto text-center" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="glass-card rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-73">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-1 bg-gradient-to-r from-transparent via-cyan-accent to-transparent" data-id="element-74" />

          <div className="flex justify-center mb-6" data-id="element-75">
            <div className="p-4 rounded-full bg-navy-900 border border-cyan-accent/30 text-cyan-glow shadow-[0_0_15px_rgba(0,229,255,0.2)]" data-id="element-76">
              <ClockIcon className="w-8 h-8" data-id="element-77" />
            </div>
          </div>

          <p className="text-xl md:text-2xl text-white font-medium mb-6 leading-relaxed" data-id="element-78">
            <span className="text-cyan-glow font-bold" data-id="element-79">Son las 3:14 PM.</span>{' '}
            Tienes una montaña de trabajo y decides pedirle ayuda a la IA.
            Escribes una instrucción rápida y lo que recibes es un texto
            robótico, genérico y totalmente inútil.
          </p>

          <p className="text-lg md:text-xl text-gray-400 leading-relaxed" data-id="element-80">
            Acabas de perder 10 minutos intentando corregir algo que debió
            ahorrarte horas. El problema no es la inteligencia artificial; es
            que le estás hablando como a un buscador de Google,{' '}
            <span className="text-white font-semibold italic" data-id="element-81">
              no como a un director de estrategia.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}